import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    menuListItem: {
      paddingTop: 4,
      paddingBottom: 4,
    },
    menuItem: {
      maxHeight: 32,
      fontSize: 13,
      borderRadius: 8,
      margin: "0 4px",
    },
    listItemText: {
      fontSize: 13,
      color: t.text,
    },
    queueSelectContainer: {
      minWidth: 110,
      maxWidth: 200,
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        minWidth: 100,
        maxWidth: 150,
      },
    },
    formControl: {
      margin: 0,
    },
    select: {
      height: 30,
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 500,
      color: t.textSecondary,
      backgroundColor: t.muted,
      "& .MuiSelect-root": {
        padding: "6px 28px 6px 10px",
        display: "flex",
        alignItems: "center",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: t.line,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: t.textMuted,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: t.brand,
        borderWidth: 1,
      },
      "& .MuiSelect-icon": {
        color: t.textMuted,
        right: 4,
      },
    },
    menuPaper: {
      borderRadius: t.radius.sm,
      border: `1px solid ${t.line}`,
      boxShadow: t.shadow.lift,
      marginTop: 4,
    },
  };
});

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const classes = useStyles();

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={classes.queueSelectContainer}>
      <FormControl fullWidth className={classes.formControl}>
        <Select
          multiple
          displayEmpty
          variant="outlined"
          value={selectedQueueIds}
          onChange={handleChange}
          className={classes.select}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
            PaperProps: {
              className: classes.menuPaper,
            },
            MenuListProps: {
              className: classes.menuListItem,
            },
          }}
          renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
        >
          {userQueues?.length > 0 &&
            userQueues.map((queue) => (
              <MenuItem
                dense
                key={queue.id}
                value={queue.id}
                className={classes.menuItem}
              >
                <Checkbox
                  style={{
                    color: queue.color,
                  }}
                  size="small"
                  color="primary"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <ListItemText
                  primary={queue.name}
                  classes={{ primary: classes.listItemText }}
                />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsQueueSelect;